import React, { FC } from 'react';
import { IInputAdornment, Input } from 'modules/core/components/index';
import { IFormField } from 'modules/core/types/form';

interface ITelephoneInput extends IFormField, IInputAdornment {
  format?: string;
  mask?: string;
  hideInitZeroValue?: boolean;
}

export const TelephoneInput: FC<ITelephoneInput> = ({
  name,
  rules,
  format,
  mask,
  startAdornment,
  validate,
  hideInitZeroValue,
}) => (
  <Input
    name={name}
    format={format}
    mask={mask}
    rules={rules}
    startAdornment={startAdornment}
    validate={validate}
    hideInitZeroValue={hideInitZeroValue}
    allowEmptyFormatting
  />
);
